<template>
  <a-spin :tip="$t('Loading...')" :spinning="getting_data">
    <navbar :back_path="'/log-activity-fill-detail'" :hide_bg_color="true" />
    <div style="text-align: center; width: 100%; padding: 16px">
      <div style="background-color: #fff; padding: 8px" class="text-center">
        <label class="title fs-16"> ผู้ติดตามคนที่ 1 </label>
        <label class="description fs-16"> ไม่มีข้อมูล </label>
        <a-button
          class="text-center danger-btn ant-button-label-custom"
          style="width: 150px"
          @click="r('/log-activity-follower-detail', { activity })"
        >
          <strong class="fs-16">กรอกข้อมูล</strong>
        </a-button>
      </div>
    </div>
    <div style="text-align: center; width: 100%; padding: 16px; padding-top: 0">
      <div style="background-color: #fff; padding: 8px" class="text-center">
        <label class="title fs-16"> ผู้ติดตามคนที่ 2 </label>
        <label class="description fs-16"> ไม่มีข้อมูล </label>
        <a-button
          class="text-center danger-btn ant-button-label-custom"
          style="width: 150px"
          @click="r('/log-activity-follower-detail', { activity })"
        >
          <strong class="fs-16">กรอกข้อมูล</strong>
        </a-button>
      </div>
    </div>
    <div v-if="$device != 'mobile'" class="copyright-section">
      © Copyright SCG Debenture Club. All Rights Reserved.
    </div>
  </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
export default {
  components: {
    navbar,
  },
  data: function () {
    return {
      getting_data: false,
      act_id: this.$route.query.act_id,
      step: 'info',
      hide_bg_color: false,
    };
  },
  mounted() {},
  methods: {
    r(path = 'home', query = {}) {
      this.$router.replace({ path, query });
    },
  },
};
</script>
<style scoped>
.title {
  display: block;
  font-weight: 600;
  margin: 8px 0 0 16px;
  color: #000 !important;
}
.description {
  font-weight: 300;
  margin: 20px;
  color: #000 !important;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
